import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPage} from '@Components/poster-editor/poster-editor-reducer';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.class';
import {BaseTransparencyOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-transparency-option';
import {useAppSelector} from '@/hooks';

const transparencyStates = {
  DISABLED: 'disabled',
  ON: 'on',
  OFF: 'off',
};

export function ImageBgTransparencyOption(): ReactElement<any> | null {
  if (window.posterEditor?.whiteboard?.isVideo()) {
    return null;
  }

  const currentPageObject = useAppSelector(getCurrentPage);

  if (!currentPageObject) {
    return null;
  }

  if (currentPageObject.background.details.type !== BackgroundTypeName.IMAGE) {
    return null;
  }

  if (currentPageObject.background.details.imageBackgroundItemObject.transparency === transparencyStates.DISABLED) {
    return null;
  }

  const onToggleOption = (): void => {
    const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
    if (!currentPage) {
      return;
    }
    if (!('imageBackgroundItemObject' in currentPageObject.background.details)) {
      throw new Error('Expected background to be of image type');
    }

    const currentTransparency = currentPageObject.background.details.imageBackgroundItemObject.transparency;

    if (currentTransparency !== transparencyStates.DISABLED) {
      void currentPage.background.updateFromObject({
        details: {
          imageBackgroundItemObject: {
            transparency: currentTransparency === transparencyStates.ON ? transparencyStates.OFF : transparencyStates.ON,
          },
        },
      });
    }
  };

  const isTransparencyOptionDisabled = !(
    currentPageObject.background.details.imageBackgroundItemObject.hashedFilename && currentPageObject.background.details.imageBackgroundItemObject.fileExtension
  );

  return (
    <BaseTransparencyOption
      isChecked={currentPageObject.background.details.imageBackgroundItemObject.transparency === transparencyStates.ON}
      isDisabled={isTransparencyOptionDisabled}
      onToggleOption={onToggleOption}
    />
  );
}
